import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleInfo"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 19.0357V3L3.00195 3.00003V19.0358H8.65157L11.9939 21.8375L15.3757 19.0358L21.002 19.0357ZM10.9998 15V10H12.9998V15H10.9998ZM10.9998 9H12.9998V7H10.9998V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleInfo;
